export const categories = {
  get: 'categories-received',
  put: 'categories-updated'
}
